import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const LegalNoticePage = () => {
  const { language, t } = useLanguage();

  const contentEn = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">General Information</h2>
        <p className="text-[#86868B] leading-relaxed">
          In compliance with the duty of information provided in Law 34/2002 on Information Society 
          Services and Electronic Commerce (LSSI-CE) of July 11, the following general information 
          about this website is provided:
        </p>
        <p className="text-[#86868B] leading-relaxed mt-4">
          The ownership of this website belongs to tivorao.com.
        </p>
        <p className="text-[#86868B] leading-relaxed mt-2">
          Contact email: contact.tivorao@gmail.com
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Terms and General Conditions of Use</h2>
        <p className="text-[#86868B] leading-relaxed">
          The purpose of these General Conditions of Use is to regulate access to and use of the Website. 
          Access to the Website by the User is free and generally free of charge. The use of any of the 
          Content or Services of the Website may require the User to register or accept specific conditions.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Intellectual and Industrial Property</h2>
        <p className="text-[#86868B] leading-relaxed">
          Tivorao owns all intellectual and industrial property rights of the Website, as well as all 
          elements contained therein (including but not limited to: images, sound, video, software, 
          texts, logos, color combinations, structure, design, etc.). All rights reserved. The reproduction, 
          distribution, or public communication of all or part of the contents without the express 
          authorization of Tivorao is expressly prohibited.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Applicable Law and Jurisdiction</h2>
        <p className="text-[#86868B] leading-relaxed">
          The relationship between the User and Tivorao will be governed by current Spanish legislation. 
          The parties submit to the courts and tribunals that correspond according to law.
        </p>
      </section>
    </div>
  );

  const contentEs = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Información General</h2>
        <p className="text-[#86868B] leading-relaxed">
          En cumplimiento con el deber de información dispuesto en la Ley 34/2002 de Servicios de la 
          Sociedad de la Información y el Comercio Electrónico (LSSI-CE) de 11 de julio, se facilitan 
          a continuación los siguientes datos de información general de este sitio web:
        </p>
        <p className="text-[#86868B] leading-relaxed mt-4">
          La titularidad de este sitio web la ostenta tivorao.com.
        </p>
        <p className="text-[#86868B] leading-relaxed mt-2">
          Email de contacto: contact.tivorao@gmail.com
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Términos y Condiciones Generales de Uso</h2>
        <p className="text-[#86868B] leading-relaxed">
          El objeto de las presentes Condiciones Generales de Uso es regular el acceso y la utilización 
          del Sitio Web. El acceso al Sitio Web por el Usuario tiene carácter libre y, por regla general, 
          es gratuito. La utilización de alguno de los Contenidos o Servicios del Sitio Web podrá requerir 
          el registro del Usuario o la aceptación de condiciones específicas.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Propiedad Intelectual e Industrial</h2>
        <p className="text-[#86868B] leading-relaxed">
          Tivorao es titular de todos los derechos de propiedad intelectual e industrial del Sitio Web, 
          así como de todos los elementos contenidos en el mismo (a título enunciativo y no exhaustivo: 
          imágenes, sonido, vídeo, software, textos, logotipos, combinaciones de colores, estructura, 
          diseño, etc.). Todos los derechos reservados. Se prohíbe expresamente la reproducción, distribución 
          o comunicación pública de la totalidad o parte de los contenidos sin autorización expresa de Tivorao.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Legislación Aplicable y Jurisdicción</h2>
        <p className="text-[#86868B] leading-relaxed">
          La relación entre el Usuario y Tivorao se regirá por la normativa vigente en España. 
          Las partes se someterán a los juzgados y tribunales que correspondan conforme a derecho.
        </p>
      </section>
    </div>
  );

  return (
    <div data-testid="legal-notice-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.legalNoticeTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>
          {language === 'es' ? contentEs : contentEn}
        </FadeUp>
      </div>
    </div>
  );
};

export default LegalNoticePage;
